import { getFunctions, httpsCallable } from "firebase/functions"
import { fireApp } from "@/main"

let appCheckPromise

function ensureAppCheck() {
  if (appCheckPromise) return appCheckPromise

  appCheckPromise = import('firebase/app-check').then(({ initializeAppCheck, ReCaptchaV3Provider }) => {
    return initializeAppCheck(fireApp, {
      provider: new ReCaptchaV3Provider('6Lc_c8MrAAAAABqbEYps-1QJh-tMUp0PMGbgX-ne'),
      isTokenAutoRefreshEnabled: false
    })
  })

  return appCheckPromise
}

const FirebaseFunctionsHelper = {
  async callFunction(name, data) {
    await ensureAppCheck()
    let functions = getFunctions(fireApp, "europe-west3")
    const addMessage = httpsCallable(functions, name)
    return addMessage(data)
      .then((result) => {
        // Read result of the Cloud Function.
        /** @type {any} */
        return result.data
      })
      .catch((error) => {
        // Getting the Error details.
        return error
      })
    },
    getFunctionsUrl(name) {
        return ("https://europe-west3-" + fireApp.options.projectId+".cloudfunctions.net/" + name)
    }
  // callFunctionFromURL(data, name) {
  //   const functions = getFunctions();
  //   const url = "https://europe-west3-"+functions.app.options.projectId+".cloudfunctions.net/" + name
  //
  //   const callableFunction = httpsCallableFromURL(
  //     functions,
  //     // the URL of the function
  //     url
  //   );
  //
  //   callableFunction(data).then((result) => {
  //     // Read result of the Cloud Function.
  //     console.log(result);
  //   });
  // },
}
export default FirebaseFunctionsHelper
